import { ADT3DSceneBuilderMode } from './Enums';

export const BehaviorModes = [
    ADT3DSceneBuilderMode.BehaviorIdle,
    ADT3DSceneBuilderMode.CreateBehavior,
    ADT3DSceneBuilderMode.EditBehavior
];

export const ElementModes = [
    ADT3DSceneBuilderMode.ElementsIdle,
    ADT3DSceneBuilderMode.CreateElement,
    ADT3DSceneBuilderMode.EditElement,
    ADT3DSceneBuilderMode.TargetElements
];
